module.exports = __webpack_public_path__ + "zvetseni-prsou_45_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_45_before.jpg
// module id = 1340
// module chunks = 0